import sector01 from "../../../../assets/images/Landing_Page/sector_01.webp";
import sector02 from "../../../../assets/images/Landing_Page/sector_02.webp";
import sector03 from "../../../../assets/images/Landing_Page/sector_03.webp";
import sector04 from "../../../../assets/images/Landing_Page/sector_04.webp";
import sector05 from "../../../../assets/images/Landing_Page/sector_05.webp";
import sector06 from "../../../../assets/images/Landing_Page/sector_06.webp";
import sector07 from "../../../../assets/images/Landing_Page/sector_07.webp";
import sector08 from "../../../../assets/images/Landing_Page/sector_08.webp";
import sector09 from "../../../../assets/images/Landing_Page/sector_09.webp";
import sector10 from "../../../../assets/images/Landing_Page/sector_10.webp";
import sector11 from "../../../../assets/images/Landing_Page/sector_11.webp";
import sector12 from "../../../../assets/images/Landing_Page/sector_12.webp";
import sector13 from "../../../../assets/images/Landing_Page/sector_13.webp";
import sector14 from "../../../../assets/images/Landing_Page/sector_14.webp";
import sector15 from "../../../../assets/images/Landing_Page/sector_15.webp";

const sectors = [
  {
    id: 1,
    image: sector01,
    label: "Retail Market",
    badge: "RETAILER",
    title: "YOU CAN BECOME A RETAILER IN 5 MINUTES",
    subtitle:
      "START TODAY BUILD YOUR BUSINESS TOMORROW IF YOU ARE CAPABLE OF SELLING GOODS.",
    description:
      "Discover opportunities. Create your Showcase. Start your journey. Easily connect with your customers and promote your products daily.",
    connectWith: [
      "Wholesaler",
      "Manufacturer",
      "Service Provider",
      "Farmer",
      "Transport Provider",
      "Job Provider",
      "Entrepreneur",
    ],
  },
  {
    id: 2,
    image: sector02,
    label: "Wholesaler Market",
    badge: "WHOLESALER",
    title: "YOU CAN BECOME A WHOLESALER IN 5 MINUTES",
    subtitle:
      "START TODAY BUILD YOUR BUSINESS TOMORROW IF YOU ARE CAPABLE OF SELLING IN BULK.",
    description:
      "Discover opportunities. Create your Showcase. Start your journey. Easily connect with your customers and promote your products every day.",
    connectWith: [
      "Manufacturers",
      "Service Providers",
      "Farmers",
      "Transport Providers",
      "Job Providers",
      "Entrepreneurs",
    ],
  },
  {
    id: 3,
    image: sector03,
    label: "Industrial Market",
    badge: "MANUFACTURING INDUSTRY",
    title: "YOU CAN BECOME A MANUFACTURER IN 5 MINUTES",
    subtitle:
      "START TODAY BUILD YOUR BUSINESS TOMORROW IF YOU ARE CAPABLE OF MANUFACTURING.",
    description:
      "Create your Showcase. Present what you manufacture. Discover opportunities. Connect with businesses and start building your market.",
    connectWith: [
      "Raw Material Providers",
      "Packaging Companies",
      "Wholesalers",
      "Retailers",
      "Transport Providers",
      "Service Providers",
      "Technology Companies",
    ],
  },
  {
    id: 4,
    image: sector04,
    label: "RAW Material Market",
    badge: "RAW MATERIAL",
    title: "YOU CAN BECOME A RAW MATERIAL PRODUCER OR SUPPLIER IN 5 MINUTES",
    subtitle:
      "START TODAY BUILD YOUR BUSINESS TOMORROW IF YOU ARE CAPABLE OF PRODUCING OR SUPPLYING.",
    description:
      "Create your Showcase. Present what you produce or supply. Discover opportunities. Connect with businesses and start building your market.",
    connectWith: [
      "Manufacturers",
      "Packaging Companies",
      "Wholesalers",
      "Retailers",
      "Transport Providers",
      "Job Providers",
    ],
  },
  {
    id: 5,
    image: sector05,
    label: "Gems & Jewelry Market",
    badge: "GEMS AND JEWELRY",
    title: "YOU CAN BECOME A GEMS & JEWELRY SELLER IN 5 MINUTES",
    subtitle:
      "START TODAY BUILD YOUR BUSINESS TOMORROW IF YOU ARE CAPABLE FOR GEMS AND JEWELRY PRODUCER OR SUPPLIER.",
    description:
      "Create your Showcase. Present your gems, jewelry, or related products. Discover opportunities. Connect with customers and businesses and start building your market.",
    connectWith: [
      "Customers",
      "Jewelry Manufacturers",
      "Gemstone Suppliers",
      "Wholesalers",
      "Marketing Providers",
    ],
  },
  {
    id: 6,
    image: sector06,    
    label: "2nd Hand item Market",
    badge: "USED ITEMS",
    title: "YOU CAN BECOME A USED ITEM SELLER IN 5 MINUTES",
    subtitle:
      "START TODAY TURN WHAT YOU HAVE INTO AN OPPORTUNITY IF YOU ARE CAPABLE OF THIS.",
    description:
      "Create your Showcase. Present your second hand or used items. Discover opportunities. Connect with interested customers and businesses and start building your market.",
    connectWith: [
      "Customers",
      "Used Item Buyers",
      "Retailers",
      "Repair Services",
      "Recyclers",
    ],
  },
  {
    id: 7,
    image: sector07,
    label: "Homemade Market",
    badge: "HOMEMADE",
    title: "YOU CAN BECOME A HOMEMADE BUSINESS OWNER IN 5 MINUTES",
    subtitle:
      "START TODAY BUILD YOUR BUSINESS TOMORROW IF YOU ARE CAPABLE TO MAKE SOMETHING AT HOME.",
    description:
      "Create your Showcase. Present what you make at home. Discover opportunities. Connect with customers and businesses and start building your market. Turn your skills, ideas and homemade products into a business opportunity.",
    connectWith: [
      "Customers",
      "Raw Material Providers",
      "Packaging Companies",
      "Wholesalers",
      "Retailers",
    ],
  },
  {
    id: 8,
    image: sector08,
    label: "Farming Market",
    badge: "FARMING SHOP",
    title: "YOU CAN BECOME A FARMER OR AGRICULTURAL PRODUCER IN 5 MINUTES",
    subtitle:
      "START TODAY BUILD YOUR BUSINESS TOMORROW AS A FARMER OR AGRICULTURAL PRODUCTS SUPPLIER.",
    description:
      "Create your Showcase. Present what you grow, produce, or supply. Discover opportunities. Connect with customers and businesses and start building your agricultural market.",
    connectWith: [
      "Customers",
      "Seed & Fertilizer Suppliers",
      "Equipment Providers",
      "Wholesalers",
      "Food Businesses",
    ],
  },
  {
    id: 9,
    image: sector09,
    label: "Recycled Material Market",
    badge: "RECYCLE",
    title: "YOU CAN BECOME A RECYCLING BUSINESS OWNER IN 5 MINUTES",
    subtitle:
      "START TODAY TURN RECYCLABLE MATERIALS INTO OPPORTUNITIES IF YOU ARE CAPABLE OF RECYCLE MATERIAL COLLECTION AND SUPPLY.",
    description:
      "Create your Showcase. Present the recyclable materials you collect, process, or supply. Discover opportunities. Connect with businesses and start building your market.",
    connectWith: [
      "Recycling Companies",
      "Manufacturers",
      "Raw Material Buyers",
      "Transport Providers",
    ],
  },
  {
    id: 10,
    image: sector10,
    label: "Used Vehicle Market",
    badge: "USED VEHICLE",
    title: "YOU CAN BECOME A USED VEHICLE SELLER IN 5 MINUTES",
    subtitle: "START TODAY BUILD YOUR BUSINESS TOMORROW.",
    description:
      "Create your Showcase. Present your used vehicles. Share their details. Discover opportunities. Connect with interested customers and businesses and start building your market.",
    connectWith: [
      "Customers",
      "Vehicle Dealers",
      "Spare Parts Suppliers",
      "Repair Services",
      "Financing Providers",
    ],
  },
  {
    id: 11,
    image: sector11,
    label: "Service's",
    badge: "SERVICES",
    title: "YOU CAN BECOME A SERVICE PROVIDER IN 5 MINUTES",
    subtitle:
      "START TODAY BUILD YOUR BUSINESS TOMORROW IF YOU ARE CAPABLE OF PROVIDING ANY KIND OF SERVICE IN THE MARKET.",
    description:
      "Create your Service Profile Showcase. Present the services you provide. Discover opportunities. Connect with customers and businesses and start building your market.",
    connectWith: [
      "Customers",
      "Businesses",
      "Manufacturers",
      "Retailers",
      "Technology Companies",
    ],
  },
  {
    id: 12,
    image: sector12,
    label: "Transportation",
    badge: "TRANSPORT SERVICE",
    title: "YOU CAN BECOME A TRANSPORTATION SERVICE PROVIDER IN 5 MINUTES",
    subtitle:
      "START TODAY BUILD YOUR BUSINESS TOMORROW AS A TRANSPORTATION PROVIDER.",
    description:
      "Create your Profile Showcase. Present your transportation services, vehicles, and capabilities. Discover opportunities. Connect with businesses and customers and start building your market.",
    connectWith: [
      "Manufacturers",
      "Wholesalers",
      "Retailers",
      "Farmers",
      "Food Businesses",
    ],
  },
  {
    id: 13,
    image: sector13,
    label: "Business Property",
    badge: "PROPERTY",
    title: "YOU CAN BECOME A PROPERTY PROVIDER IN 5 MINUTES",
    subtitle: "START TODAY BUILD YOUR BUSINESS TOMORROW.",
    description:
      "Create your Profile Showcase. Present your available properties, spaces, or property services. Discover opportunities. Connect with businesses and customers and start building your market.",
    connectWith: [
      "Businesses",
      "Manufacturers",
      "Offices",
      "Warehouses",
      "Investors",
    ],
  },
  {
    id: 14,
    image: sector14,
    label: "Job offer's",
    badge: "JOB OFFER",
    title: "YOU CAN BUILD A RECRUITMENT BUSINESS IN 5 MINUTES",
    subtitle: "START TODAY BUILD YOUR BUSINESS TOMORROW.",
    description:
      "Create your Profile Showcase. Present the jobs, recruitment services, and employment opportunities you provide. Discover opportunities. Connect with businesses and job seekers and start building your market.",
    connectWith: [
      "Employers",
      "Job Seekers",
      "Manufacturers",
      "Technology Companies",
    ],
  },
  {
    id: 15,
    image: sector15,
    label: "Food Service's",
    badge: "FOOD AND RESTAURANTS",
    title: "YOU CAN START YOUR FOOD BUSINESS IN 5 MINUTES",
    subtitle: "START TODAY BUILD YOUR BUSINESS TOMORROW.",
    description:
      "Create your Profile Showcase. Present your food, restaurant, catering, or food services. Discover opportunities. Connect with customers and businesses and start building your market.",
    connectWith: [
      "Customers",
      "Food Suppliers",
      "Farmers",
      "Packaging Companies",
      "Transport Providers",
    ],
  },
];

export default sectors;
